<template>
    <div class="ck-data-tables">
        <div class="ck-tbl-dynamix">
            <table id="tbl-minmax" class="table table-bordered table-hover table-inline-edit">
                <thead class="thead-dark">
                    <tr>
                        <th v-for="item in thead">
                            <div class="dataviewer-th" @click="sort(item.key)" v-if="item.sort">
                                <span>{{item.title}}</span>
                                <span v-if="params.column === item.key">
                                    <span v-if="params.direction === 'asc'">&#x25B2;</span>
                                    <span v-else>&#x25BC;</span>
                                </span>
                            </div>
                            <div v-else>
                                <span>{{item.title}}</span>
                            </div>
                        </th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <slot v-for="item in model.data" :item="item">{{ model.data }}</slot>
                </tbody>
            </table>
        </div>
        <!--<div class="row pr-4 pl-4 pt-2 mt-0 mb-2 ck-pagination">
            <div class="col-sm text-left">
                <span>Per page: </span>
                <select id="select-page-tbl-minmax" onchange="mmSelectPerPage(this);">
                    <option>10</option><option>25</option><option>50</option><option>100</option><option>500</option><option>1000</option>
                </select>
                <span> Showing </span><span id="data-from-tbl-minmax"></span> - <span id="data-to-tbl-minmax"></span> of <span id="total-data-tbl-minmax"></span>
            </div>
            <div class="col-sm text-right">
                <span>Current page: </span>
                <input type="text" id="input-page-tbl-minmax" onchange="mmInputPage(this);" style="width: 50px;" value="1">
                <span> of </span><span id="total-page-tbl-minmax"></span>
                <button id="btn-prev-tbl-minmax" onclick="mmPrevPage()" class="btn btn-default btn-sm">Prev</button>
                <button id="btn-next-tbl-minmax" onclick="mmNextPage()" class="btn btn-default btn-sm">Next</button>
            </div>
        </div>-->
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'

    import { bus } from './../../../main.js'

    export default {
        name: 'DataViewer',
        props: ['formName', 'source', 'thead', 'filter', 'create', 'title'],
        data() {
            return {
                loader: true,
                showFilter: false,
                model: {
                    data: []
                },
                params: {
                    column: 'id',
                    direction: 'desc',
                    per_page: 10,
                    page: 1,
                    search_column: 'id',
                    search_operator: 'equal_to',
                    search_query_1: '',
                    search_query_2: ''
                },
                operators: {
                    equal_to: '=',
                    not_equal: '<>',
                    less_than: '<',
                    greater_than: '>',
                    less_than_or_equal_to: '<=',
                    greater_than_or_equal_to: '>=',
                    in: 'IN',
                    not_in: 'NOT IN',
                    like: 'LIKE',
                    between: 'BETWEEN'
                }
            }
        },
        beforeMount() {
            this.fetchData()
        },
        created() {
            bus.$on("fetch-data", (data) => {
                this.fetchData();
            });
        },
        methods: {
            next() {
                if(this.model.next_page_url) {
                    this.params.page++
                    this.fetchData()
                }
            },
            prev() {
                if(this.model.prev_page_url) {
                    this.params.page--
                    this.fetchData()
                }
            },
            sort(column) {
                if(column === this.params.column) {
                    if(this.params.direction === 'desc') {
                        this.params.direction = 'asc'
                    } else {
                        this.params.direction = 'desc'
                    }
                } else {
                    this.params.column = column
                    this.params.direction = 'asc'
                }

                this.fetchData()
            },
            addForm(id) {
                bus.$emit(this.formName, {
                    form: 'add'
                });
            },
            fetchData() {
                //alert(this.$crud.fetchData());
                this.showFilter = false;
                this.loader = true;

                var vm = this
                axios.get(this.buildURL())
                    .then(function(response) {
                        console.log(response.data);
                        Vue.set(vm.$data, 'model', response.data.model);
                        vm.loader = false;
                    })
                    .catch(function(error) {
                        console.log(error)
                        if (error.response && error.response.status === 401) {
                            vm.$auth.destroyToken();
                            location.reload();
                        }
                    })
            },
            buildURL() {
                var p = this.params
                return `${this.source}?column=${p.column}&direction=${p.direction}&per_page=${p.per_page}&page=${p.page}&search_column=${p.search_column}&search_operator=${p.search_operator}&search_query_1=${p.search_query_1}&search_query_2=${p.search_query_2}`
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/users/common/DataViewer.vue